module.exports = __webpack_public_path__ + "static/image-paternalism-f2be694789f11e468e2528d6cbbadd59.jpg";